<template>
  <button
    class="gap-1.5 text-sm rounded-lg flex items-center justify-center whitespace-nowrap"
    :class="[
      appraisalClasses || 'w-full px-4 py-2.5',
      buttonStateClass,
      {
        'hover:brightness-95':
          state !== ButtonState.disabled && !isLoading && !isReviewReadOnly,
      },
    ]"
    :disabled="state === ButtonState.disabled || isLoading || isReviewReadOnly"
  >
    <SparklesIcon
      v-if="
        state === ButtonState.aiSuggestedExclusion ||
        state === ButtonState.aiSuggestedInclusion
      "
      class="w-4 h-4 fill-[#282E36]"
    />
    <HumanVerificationIcon
      v-else-if="
        state === ButtonState.included ||
        state === ButtonState.excluded ||
        state === ButtonState.fullTextCannotBeRetrieved
      "
      class="w-4 h-4"
      :class="buttonStateClass"
    />
    <slot />
    <ChevronDownIcon
      v-if="!isReviewReadOnly && arrow"
      class="size-4 fill-current"
    />
  </button>
</template>

<script lang="ts" setup>
import { ChevronDownIcon } from '@heroicons/vue/16/solid'
import SparklesIcon from '@app/components/Icons/SparklesIcon.vue'
import HumanVerificationIcon from '@app/components/Icons/HumanVerificationIcon.vue'
import { ButtonState } from '@app/types'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    state?: ButtonState
    isLoading?: boolean
    isReviewReadOnly?: boolean
    arrow?: boolean
    appraisalClasses?: string
  }>(),
  {
    state: ButtonState.inactive,
    isLoading: false,
    isReviewReadOnly: false,
    arrow: true,
    appraisalClasses: '',
  },
)
const buttonStateClass = computed(() => {
  if (props.isLoading || props.state === ButtonState.disabled)
    return 'bg-gray-100 text-gray-400 fill-gray-400'
  else if (props.state === ButtonState.excluded)
    return 'bg-red-200 text-red-800 '
  else if (props.state === ButtonState.fullTextCannotBeRetrieved)
    return 'bg-cyan-200 text-cyan-800'
  else if (props.state === ButtonState.duplicate)
    return 'bg-orange-500 text-white fill-white'
  else if (props.state === ButtonState.inactive)
    return 'bg-light-neutral-500 text-slate-800 fill-slate-800'
  else if (props.state === ButtonState.included)
    return 'bg-[#1FB356] text-white  '
  else if (props.state === ButtonState.appraised)
    return 'bg-blue-200 text-blue-800'
  else if (props.state === ButtonState.aiSuggestedInclusion)
    return 'bg-light-neutral-500 text-[#555E69] border-2  border-[#1FB356] '
  else if (props.state === ButtonState.aiSuggestedExclusion)
    return 'bg-light-neutral-500 text-[#555E69] border-2 border-[#DC2626]  '
  else return ''
})
</script>
